import list from './universityList.json'

export const universityList = list.sort()
